// Dependencies
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";

// Images
import BannerLogin from "../images2/Banner_login.png";

// Styles
import "../styles/Signup.scss";
import Swal from "sweetalert2";
import { resetPassword } from "../services/LoginService";
import useForm from "../hooks/useForm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FaHome } from "react-icons/fa";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [validated, setValidated] = useState(false);
  let dataArray;
  let initialState = {
    password: "",
    confirmPassword: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    email: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message:
        "El correo solo puede contener letras, numeros, puntos y guiones.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit } = useForm(
    initialState,
    validations
  );

  const submitForm = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      dataArray = {
        token: queryParams.get("token"),
        email: queryParams.get("email"),
        password: formData.password,
      };
      try {
        await resetPassword(dataArray);
        Swal.fire({
          title: "Se ha actualizado la contraseña!",
          text: "Por favor inicie sesión con su nueva contraseña.",
          icon: "success",
          confirmButtonText: "Iniciar Sesión",
          denyButtonText: "Ir al Inicio",
          showDenyButton: true,
          confirmButtonColor: "#0044aa",
          denyButtonColor: "#6f6767",
        }).then((e) => {
          if (e.isConfirmed) {
            navigate("/login");
          } else if (e.isDenied) {
            navigate("/");
          }
        });
      } catch (error) {
        console.error("Hubo un error al restablecer la contraseña:", error);
        Swal.fire({
          icon: "error",
          title: "Hubo un error al restablecer la contraseña.",
          text: "Algo salio mal al intentar restablecer la contraseña, por favor intente más tarde.",
        });
      }
    }
    setValidated(true);
  };

  return (
    <div>
      <img
        src={BannerLogin}
        alt="Banner Sign Up"
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />
      <Form
        className="signup-form needs-validation rounded-4 shadow"
        onSubmit={submitForm}
        // onSubmit={(e) => handleSubmit(e, submitForm)}
        noValidate
        validated={validated}
      >
        <Row className="m-0">
          <Col xs={12}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Ir al Inicio</Tooltip>}
            >
              <Button onClick={() => navigate("/")} variant="secondary">
                <FaHome />
              </Button>
            </OverlayTrigger>
          </Col>
          <Col xs={12} className="text-center">
            <img
              src={
                "https://panel.marzahtravel.com/assets/img/logoHeaderBlanco.png"
              }
              className="w-auto"
              alt=""
            />
          </Col>
          <Col lg={6} md={6} xs={6}>
            <Form.Group controlId="formPassword">
              <Form.Label className="text-white">Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                isInvalid={validated && formData.password.length < 6}
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese una contraseña válida.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label className="text-white">Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                isInvalid={
                  validated && formData.confirmPassword !== formData.password
                }
              />
              <Form.Control.Feedback type="invalid">
                La contraseña no coincide.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={12} md={12} sm={12} className="mt-3">
            <p className="text-white">
              Ya me acordé de mi contraseña.{" "}
              <Link className="text-white" to="/login">
                Iniciar sesión
              </Link>
            </p>
            <Form.Group controlId="formSubmit" className="text-end">
              <Form.Label></Form.Label>
              <Button className="btn-register" type="submit">
                Restablecer Contraseña
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
